import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	inheritedProject: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inheritedProjectTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	inheritedProject: {
		id: 'issue-field-atlas-project-common.atlas-project-smart-link.inherited-project',
		defaultMessage: 'Inherited',
		description: 'Text to indicate that a given project is inherited',
	},
	inheritedProjectTooltip: {
		id: 'issue-field-atlas-project-common.atlas-project-smart-link.inherited-project.tooltip',
		defaultMessage: 'Learn where this project comes from',
		description: 'Tooltip text for inherited project indicator',
	},
});
export default messages;
